var map = {
	"./0.jpg": 23193,
	"./1.jpg": 20809,
	"./2.jpg": 82340,
	"./3.jpg": 71870,
	"./4.jpg": 64274,
	"./5.jpg": 99830,
	"./6.jpg": 96247,
	"./7.jpg": 16654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41023;